import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterWalletsView.
 * Extends JetView to create a view for filtering wallets.
 */
export default class FilterWalletsView extends JetView {
    /**
     * Configures the layout of the FilterWalletsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span>ID"), // ID label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for ID input
                        },
                        {
                            view: 'text',
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'), // Name label
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder for Name input
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            label: "<span class='icon-state'></span>" + _('Estado'), // State label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for State selection
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all states
                                { id: 'A', value: _('Activado') }, // Option for activated state
                                { id: 'I', value: _('Inactivado') }, // Option for deactivated state
                            ],
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 290 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { gravity: 1, id: 'grav' }, // Gravity for responsive layout
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form inputs
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('wallets:filter', [filterdata]); // Trigger filter event
                                $$('b5').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section2], // Main layout of the view
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity element on small screens
            }
        });
    }
}

// FILE DOCUMENTED
